import React from 'react'
import styled from 'styled-components/macro'
import { useTranslation } from 'react-i18next'
import { Button } from '@resultadosdigitais/tangram-components'

const StyledButton = styled(Button)`
  width: 100%;
  display: inline-block;
  text-align: center;
`

function FluidButton({ children, loading, type, 'data-testid': data_testid }) {
  const { t } = useTranslation()
  let content = children
  if (loading) content = t('Button.Wait')
  return (
    <StyledButton type={type} disabled={loading} data-testid={data_testid}>
      {content}
    </StyledButton>
  )
}

export default FluidButton
